<div class="d-flex flex-column">
  <div class="d-flex flex-column justify-content-center p-2">
    <div class="d-flex justify-content-between center p-2">
      <label>{{'name_funnel'| translate}}</label>
      <input class="w-50" type="text" (input)="funnelName" [(ngModel)]="funnelName" (keydown.enter)="onSaveClick()">
    </div>

    <div class="d-flex justify-content-end gap-2" mat-dialog-actions>
      <app-button (onChangeClick)="onCancelClick()" [btnType]="'cancel'">
        <span>
          {{'cancel' | translate}}
        </span>
      </app-button>

      <app-button class="btn-submit ms-2" (onChangeClick)="onSaveClick()">
        {{ 'save' | translate }}
      </app-button>
    </div>
  </div>
</div>
